
export default function CheckOrderStatus(orderStatusCode) {

    if(orderStatusCode == 0){
        return "Pending"
    }
    else if(orderStatusCode == 1){
        return "Confirmed"
    }
    else if(orderStatusCode == 2){
        return "Packing"
    }
    else if(orderStatusCode == 3){
        return "Order billing"
    }
    else if(orderStatusCode == 4){
        return "Ready for delivery"
    }
    else if(orderStatusCode == 5){
        return "Rider Assigned"
    }
    else if(orderStatusCode == 6){
        return "Out for delivery"
    }
    else if(orderStatusCode == 7){
        return "Delivered"
    }
    else if(orderStatusCode == 8){
        return "Cancelled"
    }
    else if(orderStatusCode == 9){
        return "Out of stock"
    }
    else if(orderStatusCode == 10){
        return "Invalid delivery address"
    }
    else if(orderStatusCode == 11){
        return "Failed"
    }
    else if(orderStatusCode == 12){
        return "Failed no items cart"
    }
    else if(orderStatusCode == 13){
        return "Query cart not called"
    }
    else if(orderStatusCode == 14){
        return "The coupon is invalid. Please remove the coupon and proceed with placing the order."
    }
    else if(orderStatusCode == 15){
        return "Delivery date expired"
    }
    else if(orderStatusCode == 16){
        return "Billing changed"
    }
    else{
        return "order status unknown"
    }

}

const ORDER_STATUS = Object.freeze({
  INITIATED: 0,
  CONFIRMED: 1,
  PACKING: 2,
  BILLING: 3, 
  READY_FOR_DELIVERY: 4,
  RIDER_ASSIGNED: 5,
  OUT_FOR_DELIVERY: 6,
  DELIVERED: 7,
  CANCELLED: 8,
  FAILED_OUT_OF_STOCK: 9,
  FAILED_INVALID_DELIVERY_ADDRESS: 10,
  FAILED: 11,
  FAILED_NO_ITEMS_CART: 12,
  QUERY_CART_NOT_CALLED: 13,
  COUPON_INVALID: 14,
  DELIVERY_DATE_EXPIRED: 15,
  BILLING_CHANGED: 16
  
})